import { LegalShell, H2, P, UL } from "./LegalShell";
import { COMPANY, CONTACT } from "@/data/content";

export default function Privacy() {
  return (
    <LegalShell
      testid="page-legal-privacy"
      overline="Legal"
      title="Privacy Policy"
      updated="Pending solicitor sign-off"
      seoDesc="TWORAY Ltd Privacy Policy — how we collect, use and protect your personal data under UK GDPR."
    >
      <P>{COMPANY.name} ("we", "us", "our") is the data controller for personal data collected through this website. This policy explains what we collect, why, our lawful bases, how long we keep it, and your rights under UK GDPR.</P>

      <H2>1. Who we are</H2>
      <P>{COMPANY.name}, registered in {COMPANY.jurisdiction}{COMPANY.regNumber ? ` (Company No. ${COMPANY.regNumber})` : ""}. Data protection contact: <a href={`mailto:${CONTACT.privacyEmail}`} className="text-brandblue font-semibold">{CONTACT.privacyEmail}</a>. We will publish our ICO registration here once confirmed.</P>

      <H2>2. What we collect</H2>
      <UL items={[
        "Enquiry data you submit: name, company, job title, business email, phone, company size, area of interest and the details you share about your needs.",
        "Consent records: your privacy acknowledgement and, if given, marketing opt-in.",
        "Technical data: limited to what is strictly necessary to operate and secure the site (e.g. server logs).",
        "Analytics data: only if you accept analytics cookies (denied by default until consent).",
      ]} />

      <H2>3. Lawful bases</H2>
      <UL items={[
        "Responding to your enquiry: performance of a contract and/or our legitimate interests in responding to prospective clients. We do not require a marketing tickbox to respond to you.",
        "Marketing communications: your consent (Art 6(1)(a)) — optional and separately given.",
        "Analytics/advertising cookies: your consent (Art 6(1)(a)).",
        "Security and legal compliance: our legitimate interests and legal obligations.",
      ]} />

      <H2>4. How long we keep it</H2>
      <P>Enquiry data from prospects or unsuccessful enquiries is retained for up to 24 months from your last interaction with us, after which it is deleted or anonymised. Client data is retained for the duration of our engagement and as required by law thereafter. We store creation and last-contacted timestamps to enforce these periods.</P>

      <H2>5. Who processes your data (our stack)</H2>
      <P>We use a limited set of processors to run this website and communicate with you. This section reflects our actual technology stack:</P>
      <UL items={[
        "Cloud hosting provider (application and website hosting, EU/UK region).",
        "MongoDB (database storage of enquiry records, EU/UK region).",
        "Resend / SendGrid (transactional email — enquiry notifications and auto-replies), to be activated at go-live.",
        "Google Analytics (website analytics) — only where you have accepted analytics cookies.",
      ]} />
      <P className="text-sm italic">Note: earlier draft references to Wix and Calendly do not apply — we do not use those services.</P>

      <H2>6. International transfers</H2>
      <P>Where any processor transfers data outside the UK/EEA, we rely on appropriate safeguards such as adequacy decisions or Standard Contractual Clauses.</P>

      <H2>7. Your rights</H2>
      <UL items={[
        "Access, rectification, erasure, restriction, portability and objection.",
        "Withdraw consent at any time (e.g. unsubscribe from marketing).",
        "Complain to the Information Commissioner's Office (ICO) at ico.org.uk.",
      ]} />
      <P>To exercise any right, contact <a href={`mailto:${CONTACT.privacyEmail}`} className="text-brandblue font-semibold">{CONTACT.privacyEmail}</a>.</P>

      <H2>8. Cookies</H2>
      <P>We use strictly-necessary cookies to run the site. Non-essential (analytics/advertising) cookies are blocked until you consent via our cookie banner. See our Cookie Notice for detail.</P>
    </LegalShell>
  );
}
